<template>
  <component :is="currentComponent" :key="deviceClass" />
</template>

<script>
import pcContent from '@/components/ModelTwo/pcContent.vue'
import h5Content from '@/components/ModelTwo/h5Content.vue'
export default {
  components: { pcContent, h5Content },
  name: 'pageModel2',
  data() {
    return {}
  },
  computed: {
    currentComponent() {
      return this.deviceClass == 'pc' ? 'pcContent' : 'h5Content'
    },
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  created() {},
  methods: {},
}
</script>
